/**
 * LogoScroller
 *
 * Duplicates logo items in both tracks so the CSS translateX(-50%) animation
 * loops seamlessly. Both tracks get identical content → they stay in sync.
 */
class LogoScroller {
  constructor(el) {
    this.el = el;
    this.tracks = [...el.querySelectorAll('.logo-scroller__track')];
    this._init();
  }

  _init() {
    this.tracks.forEach((track) => {
      const originals = [...track.children];
      originals.forEach((item) => {
        const clone = item.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        track.appendChild(clone);
      });
    });

    // Pause until all images loaded
    this.tracks.forEach(t => t.style.animationPlayState = 'paused');

    const images = [...this.el.querySelectorAll('img')];
    const loads = images.map(img =>
      img.complete ? Promise.resolve() : new Promise(r => { img.onload = r; img.onerror = r; })
    );

    Promise.all(loads).then(() => {
      this._syncTrackWidths();
      this.tracks.forEach(t => t.style.animationPlayState = 'running');
    });
  }

  _syncTrackWidths() {
    // Force both tracks to same width so they stay in sync
    const grayTrack = this.tracks.find(t => t.classList.contains('logo-scroller__track--gray'));
    if (!grayTrack) return;
    const w = grayTrack.scrollWidth;
    this.tracks.forEach(t => t.style.width = `${w}px`);
  }
}

document.querySelectorAll('.logo-scroller').forEach((el) => new LogoScroller(el));

export default LogoScroller;